import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Button,
} from '@/components/ui';

interface ActivateMerchantConfirmProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Display name (or raw id) of the merchant being (de)activated. */
  merchantName: string;
  /** true = activating, false = deactivating — drives the copy + button. */
  enabled: boolean;
  onConfirm: () => void;
  isPending: boolean;
}

/**
 * Aktivierungs-/Deaktivierungs-Confirm (Spec 497 Inc 2, D-Components).
 *
 * Einstiegs-agnostisch (nur Props). `enabled` waehlt den Text: Aktivieren erklaert die
 * Provisionierung (Salt + Facade-Credential, Reveal folgt); Deaktivieren erklaert das
 * Pausieren (Geheimnisse bleiben). Wiederverwendbar in Inc 2b.
 */
export function ActivateMerchantConfirm({
  open,
  onOpenChange,
  merchantName,
  enabled,
  onConfirm,
  isPending,
}: ActivateMerchantConfirmProps) {
  const { t } = useTranslation('payment-link');

  const title = enabled ? t('confirm.activateTitle') : t('confirm.deactivateTitle');
  const body = enabled
    ? t('confirm.activateBody', { merchant: merchantName })
    : t('confirm.deactivateBody', { merchant: merchantName });
  const submit = enabled ? t('confirm.activateSubmit') : t('confirm.deactivateSubmit');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{body}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isPending}>
            {t('confirm.cancel')}
          </Button>
          <Button
            variant={enabled ? 'default' : 'destructive'}
            onClick={onConfirm}
            disabled={isPending}
          >
            {submit}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
